import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link,useOutletContext } from "react-router-dom";
import { currency_converter_inr, currency_converter_selected } from "../../../utils/currencyUtils";
import ProgressBar from "react-bootstrap/ProgressBar";
import { MaterialReactTable } from "material-react-table";
import { openInAppTab } from "../../../utils/tabNavigation";

function Clients() {
  const { selectedUser, year, setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [filterType, setFilterType] = useState("all");
  const [allClients, setAllClients] = useState([]);
    function RevenueCounter({ value, format = true }) {
        const safeValue = Number(value) || 0;
        return (
            <CountUp
                start={0}
                end={safeValue}
                duration={1}
                formattingFn={format ? currency_converter_selected : undefined}
            />
        );
    }  

    const handleFilter = (type) => {
        if (filterType === type) {
          setFilterType("all");
          setoptions(allClients);
          return;
        }

        setFilterType(type);

        const filtered = allClients.filter((item) => {
          const status = item.client_status?.toLowerCase().replace("-", " ").trim();

          if (type === "prospective") {
            return ["prospective", "pending"].includes(status);
          }

          if (type === "active") {
            return ["active"].includes(status);
          }

          if (type === "inactive") {
            return ["inactive", "expired", "old"].includes(status);
          }

          return true;
        });

        setoptions(filtered);
      };

  useEffect(()=>{
    if(!selectedUser) return;
    let isLatest = true; 
    const getOverview = async ()=>{
    try{
    setGlobalLoading(true);    
    const response = await axios.get(`${REACT_APP_API_BASE_URL}/performance/clients`,
     {
        params:{ user_id:selectedUser.id, year:year },
        headers: { Authorization: `Bearer ${token}` },
     }
    );
     if (!isLatest) return;
    const d = response.data;
    setAllClients(response.data.client_summary || []);
    setoptions(response.data.client_summary || []);
    console.log("clients response", response.data);
    if(response.status === 200) {
      //  const current_revenue = d?.client_list?.[0]?.total_revenue || 0;
        const current_revenue = d?.client_revenue?.[0]?.total_revenue || 0;
        const revenue_generated = d?.revenue_generated?.[0]?.total_revenue || 0;
        const total_clients = (d?.client_list?.[0]?.client_count || 0) + (d?.prospective_clients?.[0]?.prospective_count || 0);
      //  const total_clients = d?.client_summary?.length ?? 0;
        setData({
          ...d,
        current_revenue,
        total_clients,
        revenue_generated
        });
    }

    }catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getOverview();
     return () => {
        isLatest = false; // cancel old request
    };
    
    },[selectedUser,year]);

 const columns = [
    {
      accessorKey: "company_name",
      header: "Company Name",
      size: 300,
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 3,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 1,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      Cell: ({ row }) => {
        return (
          <div className="d-flex align-items-center file-name-icon">
            <a
              href={`/client/view/${row.original.client_id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${row.original.client_id}`); }}
              className="avatar avatar-md border rounded-circle"
              target="_blank"
            >
              <img
                src={
                  row.original.logo
                    ? `${PINE_BASE_URL}/files/companyLogo/${row.original.logo}`
                    : `${PINE_BASE_URL}/files/companyLogo/nologo.png`
                }
                className="img-fluid"
                alt="logo"
                style={{ width: "40px", height: "40px", objectFit: "contain" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${PINE_BASE_URL}/files/companyLogo/nologo.png`;
                }}
              />
            </a>
            <div className="ms-2">
              <h6 className="fw-medium mb-0">
                <Link
                  to={`/client/view/${row.original.client_id}`}
                >
                  {row.original.company_name}
                </Link>
              </h6>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "client_status",
      header: "Status",
      size: 100,
    },
    {
      accessorKey: "current_revenue",
      header: `Revenue`,
      size: 100,
      Cell: (info) => currency_converter_selected(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "collection_percentage",
      header: `Collection`,
      size: 100,
      Cell: (info) => {
        const value = info.cell.getValue() ?? 0;
        return `${value}%`;
        }
    },
    {
      accessorKey: "active_roles",
      header: "Active",
      size: 70,
    },
    {
      accessorKey: "total_closed",
      header: "Closed",
      size: 70,
    },
    {
      accessorKey: "averageFee",
      header: "Average Fee",
      size: 100,
      Cell: (info) =>
        info.cell.getValue() !== null ? info.cell.getValue() + "%" : "NA",
    },
  ];


  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="border-bottom mb-3 pb-3">
            <h4>Clients</h4>
            <p className="text-muted fs-13 mb-1">Complete view of client portfolio & pipeline</p>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-building`}></i>
                                Total Clients
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data?.total_clients || 0)} format={false}/></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-arrow-trend-up`}></i>
                                Revenue Generated
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data.revenue_generated)} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-check-circle`}></i>
                                Revenue Delivered
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data?.current_revenue)} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-exclamation-circle`}></i>
                                At Risk
                            </p>
                            <h3 className="counter text-warning">{data?.client_atrisk?.[0]?.total_companies || 0}</h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
          </div>
          <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                <h5>Client Journey Funnel</h5>
          </div>
          <div className="row">
            <div className="col-xl-4 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "prospective" ? "border border-warning" : ""}`} onClick={() => handleFilter("prospective")}>
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Prospective / Pending <span className="fs-14 fw-medium mb-0 text-warning mb-1 ms-1">{data?.prospective_clients?.[0]?.prospective_count || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_clients || 1}
                    variant="warning"
                    now={data?.prospective_clients?.[0]?.prospective_count || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-4 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "active" ? "border border-success" : ""}`} onClick={() => handleFilter("active")}>
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Active <span className="fs-14 fw-medium mb-0 text-success mb-1 ms-1">{data?.client_list?.[0]?.active_count || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_clients || 1}
                    variant="success"
                    now={data?.client_list?.[0]?.active_count || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-4 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "inactive" ? "border border-danger" : ""}`} onClick={() => handleFilter("inactive")}>
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Inactive / Expired <span className="fs-14 fw-medium mb-0 text-danger mb-1 ms-1">{data?.client_list?.[0]?.inactive_count || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_clients || 1}
                    variant="denger"
                    now={data?.client_list?.[0]?.inactive_count || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
          </div> 

          <div className="row">
            <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={options}
                initialState={{
                  pagination: { pageSize: 200 },
                }}
                muiTableBodyRowProps={{
                  sx: {
                    height: "20px", // compact row height
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
              />
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Clients;
